import React from "react";

import HeaderTableComponents from "./HeaderTableComponents";
import RowsComponents from "./RowsComponents";
import "./styles.css";

const ComponentsTable = ({
  rows,
  componentsPicked,
  handlePickedComponent,
  handlePickedAllComponents,
  selectedAll,
  // handleSortChange,
  // sort,
}) => {
  return (
    <div className="components-table">
      <HeaderTableComponents
        handlePickedAllComponents={handlePickedAllComponents}
        selectedAll={selectedAll}
        // handleSortChange={handleSortChange}
        // sort={sort}
      />

      <RowsComponents rows={rows} componentsPicked={componentsPicked} handlePickedComponent={handlePickedComponent} />
    </div>
  );
};

export default ComponentsTable;
